<template>
  <div class="container">
    <div class="header">
      <p style="color:#526069;font-size: 18px">商户交易数据</p>
      <el-button
        type="primary"
        style="height: 35px;width: 126px;line-height: 10px;color: #fff;"
        @click="exportExcel"
        :disabled="excelBtn"
      >导出报表</el-button>
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;">
      <el-form-item label="订单编号:">
        <el-input  v-model="formInline.orderId" placeholder="请输入订单编号"></el-input>
      </el-form-item>

      <el-form-item class="efi" label="店铺名称:">
        <el-autocomplete  v-model="formInline.name" placeholder="请输店铺名" :fetch-suggestions="querySearchAsync"></el-autocomplete>
      </el-form-item>
      <el-form-item class="efi" label="类型:">
        <el-select v-model="formInline.type" placeholder="请选账单类型">
          <el-option label="申请提现" value="3"></el-option>
          <el-option label="提现驳回" value="4"></el-option>
          <el-option label="收入" value="1"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item class="efi" label="支付渠道:">
        <el-select  v-model="formInline.payType" placeholder="请选支付渠道">
          <el-option label="全部" value="0"></el-option>
          <el-option label="微信" value="2"></el-option>
          <el-option label="支付宝" value="3"></el-option>
          <el-option label="润泽钱包" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="header">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        style="text-align: left;"
      >
        <el-form-item label="时间范围:">
          <el-date-picker
              v-model="dateTimes"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          <!-- <el-col :span="11">
            <el-date-picker :clearable="false" 
              type="date"
              placeholder="选择查询起始时间"
              v-model="formInline.date1"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
          <el-col :span="2" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-date-picker :clearable="false" 
              type="date"
              placeholder="选择查询结束时间"
              v-model="formInline.date2"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col> -->
        </el-form-item>
      </el-form>
      <!-- <div class="total">{{totalStr}}</div> -->
      <div style="margin-right: 20px;min-width:140px;">
        <el-button
          type="primary"
          style="height: 35px;line-height: 10px;"
          @click="getMerchantDealData(1)"
        >查询</el-button>
        <el-button type="info" style="height: 35px;line-height: 10px;" @click="reset">重置</el-button>
      </div>
    </div>
    <total :data = "totalData"></total>
    <el-table
      :data="tableData"
      stripe
      :header-cell-style="cell"
      :row-style="row"
      style="width: 100%;"
    >
      <el-table-column align="center" prop="ref_order_id" label="订单编号" width="180"></el-table-column>
      <el-table-column align="center" prop="name" label="店铺名称" ></el-table-column>
      <el-table-column
        align="center"
        prop="orderType"
        :formatter="typeFormat"
        label="类型"
      ></el-table-column>
      <el-table-column align="center" prop="amount" :formatter="tofixed" label="金额(元)"></el-table-column>
      <el-table-column
        align="center"
        prop="channel"
        :formatter="channelFormat"
        label="支付渠道"
      ></el-table-column>
      <el-table-column align="center" prop="tradeName" label="交易方" ></el-table-column>
      <el-table-column align="center" :formatter="dateFormat" prop="create_time" label="时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div 
            class="refundBtn"
            v-show="scope.row.orderType == 5"
            @click="toViewDetail(scope.row.ref_order_id)"
          >退款详情</div>
        </template>  
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagi"
      background
      layout="prev, pager, next,jumper"
      :total="total"
      @current-change="getMerchantDealData"
    ></el-pagination>
    <!-- 退款记录弹框 -->
    <el-dialog 
      title="退款记录" 
      width="458px" 
      :visible.sync="refundRecord">
      <el-form 
        label-width="50" 
        class="record"
        ref="form"
        :inline="true"
      >
        <div class="dataList">
          <div class="refundDate">
            <span class="refundTime">订单金额 ：￥{{refundRecordData.orderAmount?refundRecordData.orderAmount:0}}</span>
            <span class="refundTime">退款金额 ：￥{{refundRecordData.refundAmount?refundRecordData.refundAmount:0}}</span>
          </div> 
          <div class="refundDate" v-show="refundRecordData.channel == 3">
            <span class="refundTime" >退款手续费 ：{{refundRecordData.fee}}</span>
          </div>      
          <div class="refundDate">
            <span class="refundTime">退款渠道 ：{{refundRecordData.channel == 1?'园区钱包':refundRecordData.channel == 2?'微信支付':'支付宝支付'}}</span>
             <span class="refundTime">退款状态 ：{{refundRecordData.status == 1?'退款成功':'待入账'}}</span>
          </div>
          <div class="refundMothod">
            <span class="proson">用户名称 ：{{refundRecordData.realname}}</span>
            <span class="proson">操作人 ：{{refundRecordData.handlerName}}</span>
          </div>
          <div class="refundDate">
            <span class="refundTime">退款时间 ：{{refundRecordData.createTime}}</span>
            <span class="refundTime">到账时间 ：{{refundRecordData.updateTime}}</span>
          </div>
          <div class="orderId">
            <span class="text">退款编号 ：{{refundRecordData.refundOrderId}}</span>
          </div> 
          <div class="oldOrderId">
            <span class="text">
              <span class="number">原订单编号 ：<span id="target">{{refundRecordData.sourceOrderId}}</span>  </span> 
              <span class="font" @click="copyOrderId" data-clipboard-target="#target">复制</span>
              </span>
          </div>    
          <div class="refundNote">
            <span class="refundNoteName">退款备注 ：</span>
            <span class="refundNoteText">{{refundRecordData.desc?refundRecordData.desc:'无'}}</span>
          </div>
        </div>
      </el-form>
		</el-dialog>
  </div>
</template>

<script>
import { getMerchantDeal,getMerchantByStr,refundDetail} from "@/api/finance";
import { toFixed, compareTime } from "@/utils";
import { downloadExcel } from "@/utils/downloadFetch";
import Total from '@/components/Total2.vue'
import { setTimeout } from 'timers';
import Clipboard from 'clipboard';  
import {shop_url} from '@/global';
export default {
  name: "",
  props: [""],
  components:{Total},
  data() {
    return {
      t: 9.8,
      formInline: {
        orderId: "",
        name: "",
        type: "",
        payType:'0',
        start: "",
        end: ""
      },
      total: 0,
      page: 1,
      pageSize: 10,
      tableData: [],
      totalStr: "", //用于展示总价
      totalData:{},
      dateTimes : '',
      hidden:true,
      pickerOptions: {
        shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
      refundRecordData:{},
      refundRecord:false,
      excelBtn:false
    };
  },
  watch: {
    dateTimes:function (val){
      console.log(val)
      this.formInline.start = val[0];
      this.formInline.end = val[1];
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.getMerchantDealData(1);
    })
  },
  methods: {
    tofixed(row, column, cellValue) {
      return toFixed(cellValue);
    },
    cell() {
      return {
        textAlign: "center",
        color: "#526069",
        fontSize: "14px"
      };
    },
    row() {
      return {
        height: "36px",
        textAlign: "center",
        color: "#7d8893",
        fontSize: "14px"
      };
    },
/* 店铺名的输入联想，实际上是调用接口去查询 */
    querySearchAsync(queryString, cb) {
       getMerchantByStr(queryString?queryString:"").then(res=>{
          if(res.data){
            /* 这里需要把对象数组 变成组件要求的数组 */
            let names = [];
            res.data.data.forEach(element => {
              names.push({value:element.name})
            });
            cb(names)
          }
       }).catch(err=>{

       })
    },
    getMerchantDealData(page) {
      this.page = page;
      // let { date1, date2 } = this.formInline;
      // let flag = compareTime(date1, date2);
      // console.log(this.formInline);
      // if (flag) {
        console.log(this.formInline);
        getMerchantDeal(this.formInline, page, this.pageSize).then(res => {
          // this.totalStr = `选中时间内总收入：${
          //   res.data.totalInconme
          // }元（其中 微信：${res.data.wxPay}元 支付宝：${
          //   res.data.aliPay
          // }元 园区支付：${res.data.rangePay}元 ），总支出：${
          //   res.data.totalPay
          // }元`;
          this.totalData = {
            totalInconme:res.data.totalInconme,
            wxPay:res.data.wxPay,
            aliPay:res.data.aliPay,
            rangePay:res.data.rangePay,
            totalPay:res.data.totalPay,
            totalCount:res.data.count,
            couponPay:res.data.couponPay || 0,
          }
          this.tableData = res.data.list;
          this.total = res.data.count;
        });
      // } else {
      //   this.$notify({
      //     title: "提示",
      //     message: "请正确选择时间",
      //     type: "warning",
      //     duration: 800
      //   });
      // }
    },
    exportExcel() {
      this.excelBtn = true;
      downloadExcel({
        method: "post",
        fileName:'商户交易数据报表.xls',
        url: `${shop_url}/shop/cms/print/mch`,
        data: this.formInline
      }).then(res => {
        this.excelBtn = false;
        console.log(res);
      }).catch(err => {
        this.excelBtn = false;
      });
    },
    reset() {
      this.formInline.name = "";
      this.formInline.orderId = "";
      this.formInline.type = "";
      this.formInline.start = "";
      this.formInline.end = "";
      this.getMerchantDealData(1);
    },
    dateFormat(row, column) {
      return this.uwsToDate(row[column.property]);
    },
    typeFormat(row, column) {
      let str = "";
      switch (row[column.property]) {
        case 1:
          str = "收入";
          break;
        case 3:
          str = "申请提现";
          break;
        case 4:
          str = "提现驳回";
          break;
        case 5:
          str = "退款";
          break;
      }
      return str;
    },
    channelFormat(row, column) {
      let str = "";
      switch (row[column.property]) {
        case 1:
          str = "园区钱包";
          break;
        case 2:
          str = "微信";
          break;
        case 3:
          str = "支付宝";
          break;
        case 4:
          str = "--";
          break;
      }
      return str;
    },
    toViewDetail (id) {
      refundDetail(id).then(res => {
        console.log(res);
        this.refundRecordData = res.data;
        this.refundRecord = true;
      }).catch(error => {
        console.log(error);
      })
    },
    copyOrderId () {
      var clipboard = new Clipboard('.font');  
      clipboard.on('success', e => {  
        this.$message({
          message: "已复制到剪切板"
        });
        console.log("复制成功");//这里你如果引入了elementui的提示就可以用，没有就注释即可
        // 释放内存  
        clipboard.destroy(); 
      })  
      clipboard.on('error', e => {  
        // 不支持复制  
        console.log('该浏览器不支持自动复制')  
        // 释放内存  
        clipboard.destroy()  
      })
    }
  }
};
</script>
<style lang="scss" scoped>
 .container {
  background-color: #fff;
  padding: 30px;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  justify-content: space-between;
  .total {
    width: 40%;
  }
}
.el-input {
  border-bottom: 240px #d1dee1;
}
.ein {
  width: 240px;
}
.efi {
  margin-left: 50px;
}
.pagi {
  align-self: center;
  margin-top: 24px;
}
.refundBtn{
  cursor: pointer;
  color:#409EFF;
}
.record{
  height:auto;
  .total{
    width:100%;
    height:40px;
    display: flex;
    // padding-bottom:39px;
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .dataList{
    width:100%;
    height:auto;
    .userName{
      display: flex;
      font-size:12px;
      line-height:40px;
      .name{
        flex-basis: 35%;
      }
      .money{
        flex: 1;
      }
    }
    .refundMothod{
      display: flex;
      font-size:12px;
      line-height:40px;
      .mothod{
        flex-basis: 50%;
      }
      .proson{
        flex: 1;
      }
    }
    .refundDate{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundTime{
        flex-basis: 50%;
      }
      .arriveTime{
        flex: 1;
      }
    }
    .orderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 50%;
      }
    }
    .oldOrderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 100%;
        .font{
          cursor: pointer;
          color:#409EFF;
          margin-left:20px;
        }
      }
    }
    .refundNote{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundNoteName{
        flex-basis: 64px;
      }
      .refundNoteText{
        flex: 1;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding:0 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/MerchantDealData.vue